module.exports = __webpack_public_path__ + "img/woman-profile.69bc68dc.svg";